export class Multiplexor {

    events: any;
    callback: any;
    data: any = {};

    constructor(events, callback) {
        this.events = events;
        this.callback = callback;
    }

    input(event, data) {
        this.data[event] = data;
        var hasAllEvents = true;
        this.events.forEach((myEvent) => {
            if (!this.data[myEvent]) {
                hasAllEvents = false;
            }
        });
        if (hasAllEvents) {
            this.callback(this.data);
        }
    }
}